import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import Button from 'components/UI/V3/Button/Button';
import { FunctionComponent, MouseEvent, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import styles from './AddRuleButton.module.scss';
import ClickAwayListener from 'react-click-away-listener';

interface AddRuleButtonProps {
    className?: string;
    onAdd?: (type: 'count' | 'size' | 'weight' | 'weightRange') => void;
}

export const AddRuleButton: FunctionComponent<AddRuleButtonProps> = props => {
    const isMobile = useMediaQuery({ query: '(max-width:600px)' });
    const [expanded, setExpanded] = useState(false);

    const clickHandler = (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        setExpanded(prev => !prev);
    };

    const clickOptionHandler = (event: MouseEvent, type: 'count' | 'size' | 'weight' | 'weightRange') => {
        event.preventDefault();
        event.stopPropagation();
        setExpanded(false);
        props.onAdd?.(type);
    };

    const list = (
        <ClickAwayListener onClickAway={() => setExpanded(false)}>
            <div className={styles.list}>
                <span
                    className={styles.option}
                    onClick={event => clickOptionHandler(event, 'count')}
                >
                    By Total Count
                </span>
                <span
                    className={styles.option}
                    onClick={event => clickOptionHandler(event, 'size')}
                >
                    By Pet Size
                </span>
                <span
                    className={styles.option}
                    onClick={event => clickOptionHandler(event, 'weight')}
                >
                    By Total Pet Weight
                </span>
                <span
                    className={styles.option}
                    onClick={event => clickOptionHandler(event, 'weightRange')}
                >
                    By Weight Range
                </span>
            </div>
        </ClickAwayListener>
    );

    return (
        <div className={styles.container}>
            <Button
                label="Add Rule"
                rightIcon={faAngleDown}
                variant="green"
                onClick={clickHandler}
            />
            {expanded && list}
        </div>
    );
};

export default AddRuleButton;
